// @flow
import React from 'react';
import type {CryptocurrencyProtocol} from '@tectonics/commons/cryptocurrency/protocol/cryptocurrency-protocol-type';
import PolygonIcon from './polygon-icon';

export const polygon: CryptocurrencyProtocol = {
  code: 'POLYGON',
  icon: <PolygonIcon alt ="Polygon Icon" />,
  name: 'Polygon (MATIC)',
  abbreviation: 'Polygon',
};
